<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)"
                srcset="assets/img/school-desktop-banners/arni-school-of-arts-and-humanities.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/school-desktop-banners/medium-screen/arni-school-of-arts-and-humanities.webp">
        <img
            src="assets/img/mobile-banners-schools/arni-school-of-arts-and-humanities.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>
<section class="aarni-font py-12">
    <div class="container mx-auto p-4">
        <div
            class="md:flex flex-wrap hidden space-x-4 p-6 xl:p-4 mb-4 border-2 border-gray-200 rounded-full gap-y-3 mx-auto xl:justify-center">
            <a href="#overview"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400  active-tab">Overview</a>
            <a href="#courses"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Courses</a>
            <a href="#specialisation"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Specialization</a>
            <a href="#dean-message"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Dean's
                Message</a>
            <a href="#whats-happening"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">What's
                Happening</a>
            <a href="#expert-faculty"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Expert
                Faculty</a>
            <!--<a href="#testimonials"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Testimonials</a>-->
            <a href="#gallery"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Gallery</a>
            <a href="#recruiters"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Recruiters</a>
        </div>

        <div id="overview" class="section p-4">
            <h2 class="text-3xl font-bold mb-2">Arni School of Arts & Humanities</h2>
            <h2 class="text-xl font-bold mb-2">Overview</h2>
            <p class="text-gray-500 text-justify">The School of Arts and Humanities at ARNI University is the place
                where culture, communication, and creativity take flight to the diversified career opportunities.
                Through our humanities and arts division, we transform knowledge and skills into cultural and societal
                insights. The humanities are considered the soul of education that helps students to understand human
                behavior, values, languages, history, and culture that shape the world.
            </p>
            <p class="text-gray-500 text-justify">Arts and Humanities courses offer an enriching blend of disciplines in
                the arts, literature, philosophy,
                social science, political science, and history. We are aiming to provide a strong base for creative
                minds who are passionate about understanding the complexities of human experience, culture, and society
                while equipping them with the critical thinking skills and perspectives to thrive in today’s
                fast-changing world.
            </p>
            <p class="text-gray-500 text-justify">We designed our programs to foster ethical reasoning, creative
                expression, critical thinking, and global awareness. At ARNI, we offer a rich blend of traditional and
                contemporary subjects—ranging from Literature, History, and Philosophy to Journalisxm, Fashion Design,
                and Psychology. With a commitment to academic freedom, interdisciplinary learning, and social
                responsibility, we prepare students for diverse careers in media, research, education, civil services,
                creative industries, and more.</p>
            <p class="text-gray-500 text-justify my-2"><strong>Vision</strong> – We have a vision of encouraging
                educational excellence, providing an inclusive environment that fosters curiosity, cultural
                understanding, and creativity with courses under the arts and humanities. We dream of becoming a
                globally recognized center for arts and humanities degrees.
            </p>
            <p class="text-gray-500 text-justify my-2"><strong>Mission</strong> – Our mission is to empower students
                with a comprehensive understanding of the human experience and the skills needed to navigate the
                complexities of a globalized society.
            </p>
        </div>

        <div id="courses" class="section px-4">
            <h2 class="text-xl font-bold mb-2">Courses</h2>
            <p class="text-gray-500 text-justify">The ARNI School of Arts & Humanities offers a wide spectrum of
                undergraduate, postgraduate, diploma, and doctoral programs. Our courses aim to enhance the
                intellectual, emotional, and social development of students while preparing them for real-world
                challenges and opportunities.
            </p>
            <p class="text-gray-500 text-justify">ARNI University's School of Arts and Humanities is a multicultural,
                encouraging, and cooperative institution that emphasizes the methodical, academic investigation of
                current social, political, and economic concerns from an interdisciplinary standpoint. In addition to
                academic pursuits, it emphasizes students' personal growth.</p>
            <p class="text-gray-500 text-justify">The provided courses are founded on the principles of high-quality
                education and skill development that lead to career prospects and the overall development of the human
                being. Students are inspired by the instructors to develop greater awareness and empathy for their peers
                and fellow citizens. Students' exposure is intended to pave the path for entrepreneurship, industrial
                requirements, research, internships, global learning, and further education.</p>
            <!--<div id="section2" class="section p-4">
                <p class="text-gray-500 text-justify">Our School of Arts and Humanities offers a wide range of
                    Undergraduate, Postgraduate, Diploma, and Doctoral programs aimed at cultivating intellectual depth,
                    creativity, and critical thinking skills across various disciplines.</p>
                <ul class="list-disc">
                    <li class="text-gray-500 text-justify my-2">
                        Undergraduate Programs
                        <ul class="list-disc ml-6">
                            <li>BA</li>
                            <li>B.A. (Hons) English</li>
                            <li>B.A/B.Sc. Clinical Psychology</li>
                            <li>B.Lib. Sc. (Bachelor of Library Science)</li>
                            <li>B.Sc. Fashion Design</li>
                            <li>Bachelor of Arts in Journalism and Mass Communication (BAJMC)</li>
                        </ul>
                    </li>
                    <li class="text-gray-500 text-justify my-2">
                        Postgraduate Programs
                        <ul class="list-disc ml-6">
                            <li>MA English</li>
                            <li>MA Economics</li>
                            <li>MA Hindi</li>
                            <li>MA Psychology</li>
                            <li>MA Public Administration</li>
                            <li>M.A. Geography</li>
                            <li>Master of Journalism and Mass Communication (MJMC)</li>
                            <li>M.Lib. Sc. (Master of Library Science)</li>
                        </ul>
                    </li>
                    <li class="text-gray-500 text-justify my-2">
                        Diploma Programs
                        <ul class="list-disc ml-6">
                            <li>Diploma in Mass Communication</li>
                        </ul>
                    </li>
                    <li class="text-gray-500 text-justify my-2">
                        Doctoral Programs (Ph.D.)
                        <ul class="list-disc ml-6">
                            <li>Ph.D. in English</li>
                            <li>Ph.D. in Economics</li>
                            <li>Ph.D. in Information & Library Science</li>
                        </ul>
                    </li>
                </ul>
                &lt;!&ndash; <p class="text-gray-500 text-justify"><strong>Scope:</strong> Graduates of these programs are prepared for careers in education, journalism, media, communication, public policy, publishing, social services, and cultural organizations, among others.</p>
                 <p class="my-2 text-gray-500 font-semibold">Join us and embark on a transformative journey through the world of arts and humanities, where your creativity and intellect are the key to global opportunities.</p>&ndash;&gt;
            </div>-->
            <p class="text-gray-500 text-justify"><strong>Scope:</strong> Through the School of Arts and Humanities, we
                encourage students to master different genres, such as English, Journalism, Fashion Design, Economics,
                Library & Information Science, Yoga, and so on. Through unique educational practices, we designed our
                curriculum with ongoing trends and techniques under the guidance of industry professionals.
            </p>
            <ul class="list-disc px-5">
                <li class="text-gray-500 text-justify my-2">Students will have the opportunity to integrate knowledge
                    from different fields and polish their knowledge and skills, aiming for different industries and
                    sectors.
                </li>
                <li class="text-gray-500 text-justify my-2">Arts and humanities students form a major portion of
                    successful civil service candidates. Their strong grasp on history, society, and politics equips
                    them for administrative and policymaking roles in IAS, IPS, and other government services.
                </li>
                <li class="text-gray-500 text-justify my-2">Students can become educators at schools, colleges, or
                    universities after completing relevant qualifications. Their in-depth understanding of culture and
                    society makes them ideal academic mentors.
                </li>
                <li class="text-gray-500 text-justify my-2">Graduates can work in NGOs, advocacy groups, and government
                    welfare departments—contributing to social development, human rights, women's empowerment, and
                    mental health awareness.
                </li>
                <li class="text-gray-500 text-justify my-2">Psychology graduates can explore roles such as counselors,
                    therapists, or researchers in clinics, educational institutions, or corporations focusing on
                    emotional wellness.
                </li>
                <li class="text-gray-500 text-justify my-2">Knowledge of languages opens doors in fields like literary
                    translation, diplomatic interpretation, subtitling, and language teaching, both in India and abroad.
                </li>
            </ul>
            <p class="my-2 text-gray-500 font-semibold">Express your thoughts, explore cultural heritage, dive into the
                endless ideas of creativity through our courses, and be a part of this ever-evolving world of arts and
                humanities. Join us now on the journey of fulfilled growth and opportunities.
            </p>
            <h2 class="text-xl font-bold">Career Opportunities</h2>
            <ul class="list-disc mb-4 px-5">
                <li class="text-gray-500  my-2"><span class="font-semibold">Journalist / Content Creator -</span>
                    Graduates can become reporters, editors, anchors, or bloggers, creating engaging content across
                    platforms like news, entertainment, and education.
                </li>
                <li class="text-gray-500  my-2"><span
                    class="font-semibold">Fashion Designer / Creative Director -</span>
                    Fashion students can work in design studios, apparel companies, or start their own labels, leading
                    design thinking and innovation.
                </li>
                <li class="text-gray-500  my-2"><span
                    class="font-semibold">Psychologist / Counselor -</span>
                    After higher studies and certification, students can practice in educational, clinical, or corporate
                    settings, promoting mental health.
                </li>
                <li class="text-gray-500  my-2"><span
                    class="font-semibold">Professor / Researcher -</span> With postgraduation and a Ph.D., students can
                    enter academia, teaching subjects like literature, philosophy, or history, and contribute to
                    impactful research.
                </li>
                <li class="text-gray-500  my-2"><span
                    class="font-semibold">NGO Professional / Public Policy Analyst -</span>
                    Work on ground-level change or policy frameworks that address societal issues, gender rights,
                    education, and environmental sustainability.
                </li>
            </ul>
            <h2 class="text-xl font-bold">ARNI University’s Contribution</h2>
            <p class="my-2 text-gray-500">We are proud to nurture individuals passionate about fields
                related to the arts and humanities. ARNI School of Arts and Humanities plays an important role in
                shaping the future of students who appreciate cultural diversity, understand human complexities, and
                lead with empathy.
            </p>
            <p class="my-2 text-gray-500">Through our learning and teaching space, we encourage creativity
                and diversity by organizing literary festivals, art exhibitions, journalism labs, and fashion shows. Our
                program enhances theoretical knowledge by covering fieldwork, media projects, fashion events, and
                community engagement, which provides our students with real-world experience. </p>
            <p class="my-2 text-gray-500">Moreover, we have a team of seasoned academicians and industry
                professionals who offer a perfect blend of theory-based learning and practical exposure. We also provide
                career counseling, internships, and research opportunities, ensuring that every student finds their
                unique voice and path.
            </p>
            <h2 class="text-xl font-bold mb-2">Why Choose ARNI?</h2>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2">Whether you are inspired by linguistics, journalism, psychology, fashion,
                    or philosophy – ARNI offers a broad and interdisciplinary education that meets individual interest
                    and industry trends.
                </li>
                <li class="text-gray-500 my-2">We are not limited to textbook learning only; we believe in practical
                    learning too. Our students engage in media production, counseling sessions, and cultural research to
                    gain real-world experience.
                </li>
                <li class="text-gray-500 my-2">We believe in inclusivity, we foster a culture of debate, creativity, and
                    social awareness, where students are encouraged to express themselves freely.
                </li>
                <li class="text-gray-500 my-2">We have a well-maintained modern infrastructure and labs, which are
                    equipped with the latest tools and equipment to encourage hands-on learning and innovation.
                </li>
                <li class="text-gray-500 my-2">We are committed to providing quality education at the most affordable
                    price to make education easily accessible to all. We provide financial support and merit-based
                    scholarships to deserving students.
                </li>
                <li class="text-gray-500 my-2">We support our students with resume building, internships, networking
                    opportunities, and placements in reputed organizations and institutions.
                </li>
            </ul>
            <p class="my-2 text-gray-500 font-semibold">Express your thoughts, explore cultural heritage, dive into the endless ideas
                of creativity through our courses, and be a part of this ever-evolving world of arts and humanities.
                Join us now on the journey of fulfilled growth and opportunities.
            </p>
        </div>
    </div>
    <div id="specialisation" class="w-full bg-gray-100">
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">Arts & Humanities Disciplines &
                Specializations</h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div
                    *ngFor="let department of departments"
                    class="bg-white p-5 rounded-2xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                >
                    <div class="flex items-center mb-4">
                        <i class="fa" [ngClass]="department.icon + ' text-2xl text-blue-600 mr-3'"></i>
                        <span class="text-xl font-semibold text-gray-800">{{ department.name }}</span>
                    </div>
                    <div class="max-h-40 overflow-y-auto custom-scrollbar pr-2">
                        <ul class="list-disc pl-6 text-sm text-gray-700 space-y-1">
                            <li *ngFor="let branch of department.branches">{{ branch }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>


        <div class="bg-gradient-to-b from-indigo-500 to-blue-400 text-white py-8  text-center mt-6">
            <div class="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 py-8">
                <div>
                    <p class="text-3xl font-bold">200+</p>
                    <p class="text-lg">Programs</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">500+</p>
                    <p class="text-lg">Faculties</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">11000+</p>
                    <p class="text-lg">Students</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">120+</p>
                    <p class="text-lg">Acre of campus</p>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full">
        <div id="dean-message"
             class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4">
            <div class="relative w-full md:w-1/3">
                <img src="assets/img/dean-as-per-schools/dr-brijesh-tiwari-arni-school-of-arts-and-humanities.png"
                     alt="Dean" class="w-full h-full object-cover">
                <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2">
                    Dr. Brijesh Tiwari
                </div>
            </div>
            <div class="w-full md:w-2/3 p-6 overflow-y-auto h-auto custom-scrollbar">
                <h2 class="text-2xl font-bold mb-2">Dean’s Message</h2>
                <p class="text-gray-700 text-justify text-lg">
                    “साहित्य, कला और दर्शन मानवता के दर्पण हैं”
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    The School of Arts & Humanities at ARNI University is not just to provide with relatable knowledge -
                    It is a place where great ideas and conversation transform into innovative concepts. Here, you will
                    have the freedom to engage with literature, culture, and creative thinkers as well as you are, in
                    the form of passionate teachers and students. We have developed a community of scholars devoted to
                    research and building a strong foundation to pursue a career in the arts and humanities.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    Through the School of Arts and Humanities, we encourage students to master different genres, such as
                    English, Journalism, Fashion design, Economics, Library & Information Science, Yoga, and so on. Our
                    esteemed faculty members, many of whom have affiliations in several areas, provide one-on-one
                    mentoring to students as they progress through their studies.
                </p>
                <p class="text-gray-700 mt-4 text-justify">We encourage you to step into this new world, where students
                    who have no other options do not turn to arts education as a last resort.</p>
                <p class="text-gray-700 mt-2 text-justify">Sincerely,</p>
                <p class="text-gray-700 mt-2 text-justify font-bold">Dr. Brijesh Tiwari</p>
                <p class="text-gray-700 mt-2 text-justify">Dean, ARNI School of Arts & Humanities
                </p>
                <p class="text-gray-700 mt-2 text-justify">ARNI University
                </p>
            </div>
        </div>

        <div id="whats-happening" class="w-full">
            <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
                <div class="container mx-auto px-6">
                    <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <div *ngFor="let event of events" class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img [src]="event.image" alt="Event Image" class="w-full h-56 object-cover">
                            <div class="p-4">
                                <span
                                    class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8">Event</span>
                                <!--<p class="text-sm text-gray-600 font-bold mt-3">{{ event.date }}</p>-->
                                <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                                <p class="text-sm text-gray-600 mt-2">{{ event.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center mt-10">
                        <a
                            href="/whats-happening/event-calendar"
                            class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                        >
                            View More
                        </a>
                    </div>
                    <!--<div class="bg-white mt-12 p-6 rounded-lg shadow-lg">
                        <h3 class="font-bold text-lg mb-4">ANNOUNCEMENTS</h3>
                        <div class="flex flex-wrap md:flex-nowrap justify-center gap-4">
                            <div *ngFor="let announcement of announcements | slice:0:3"
                                 class="w-full md:w-1/3 bg-gray-100 p-4 rounded-lg flex items-center">
                                <div class="bg-green-500 text-white font-bold text-center px-4 py-2 rounded-md">
                                    <p class="text-sm">{{ announcement.date }}</p>
                                </div>
                                <p class="ml-4 text-sm text-gray-700">{{ announcement.text }}</p>
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>

        <div id="expert-faculty" class="w-full">
            <!-- Desktop / Carousel View -->
            <div class="relative w-full md:flex flex-col items-center bg-gray-100 py-8 hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="relative w-full max-w-7xl overflow-hidden">
                    <div
                        class="flex  transition-transform duration-300 ease-in-out"
                        [ngStyle]="{ transform: 'translateX(' + translateX + '%)' }"
                    >
                        <div
                            *ngFor="let faculty of faculties"
                            class="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4"
                        >
                            <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                                <div class="h-[140px] flex items-center justify-center">
                                    <img
                                        [src]="faculty.image"
                                        alt="faculty image"
                                        class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                    />
                                </div>
                                <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                    <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                    <p class="text-sm text-gray-600 flex items-center mt-2">
                                        {{ faculty.designation }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    (click)="prev()"
                    class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-left text-[#012E26]"></i>
                </button>
                <button
                    (click)="next()"
                    class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-right text-[#012E26]"></i>
                </button>

                <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                        (click)="goTo('about/faculty')">
                    View All Faculty
                </button>
            </div>

            <!-- Mobile View -->
            <div class="relative w-full sm:flex flex-col items-center bg-gray-100 py-8 md:hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="w-full flex flex-col items-center">
                    <div
                        *ngFor="let faculty of faculties | slice:0:3"
                        class="p-4 w-full sm:w-4/5"
                    >
                        <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                            <div class="h-[140px] flex items-center justify-center">
                                <img
                                    [src]="faculty.image"
                                    alt="faculty image"
                                    class="w-32 h-32 object-fit rounded-full border-4 border-white shadow-md"
                                />
                            </div>
                            <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                <p class="text-sm text-gray-600 flex items-center mt-2">
                                    {{ faculty.designation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center">
                    <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                            (click)="goTo('about/faculty')">
                        View All Faculty
                    </button>
                </div>
            </div>
        </div>

        <!--<div id="testimonials" class="py-16 bg-white font-montserrat">
            <div class="container mx-auto px-4 text-center">
                <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
                <div class="testimonial-slider relative">
                    <div class="overflow-hidden px-2">
                        <div
                            class="flex transition-transform duration-500 ease-in-out"
                            [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                        >
                            <ng-container *ngFor="let group of groupedTestimonials">
                                <div class="w-full flex-shrink-0 flex pb-4">
                                    <div
                                        *ngFor="let testimonial of group"
                                        class="w-full md:1/2 lg:w-1/3 px-3"
                                    >
                                        <div
                                            class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                            <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                                <div
                                                    class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                                >
                                                    <div class="w-24 h-24 rounded-full bg-white p-1">
                                                        <img
                                                            [src]="testimonial.image"
                                                            [alt]="testimonial.name"
                                                            class="w-full h-full rounded-full object-cover"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-16 pb-8 px-6">
                                                <h3
                                                    class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                                >
                                                    {{ testimonial.name }}
                                                </h3>
                                                <div class="flex justify-center mb-4">
                                                    <i
                                                        class="fa fa-star text-yellow-400"
                                                        *ngFor="let star of [1, 2, 3, 4, 5]"
                                                    ></i>
                                                </div>
                                                <p class="text-gray-700 text-center mb-6">
                                                    {{ testimonial.feedback }}
                                                </p>
                                                <div class="text-center text-sm text-gray-600">
                                                    <p class="font-semibold">{{ testimonial.course }}</p>
                                                    &lt;!&ndash;  <p class="font-bold text-[#012E26]">
                                                          Placed In:
                                                          <span class="text-[#00BFA5]">
                            {{ testimonial.company }}
                          </span>
                                                      </p>&ndash;&gt;
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    &lt;!&ndash; Pagination Dots &ndash;&gt;
                    <div class="flex justify-center mt-8 space-x-2">
                        <button
                            *ngFor="let group of groupedTestimonials; let i = index"
                            [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                            class="w-3 h-3 rounded-full transition-all duration-300"
                            (click)="setTestimonialSlide(i)"
                        ></button>
                    </div>
                </div>

                <div class="flex justify-center mt-10">
                    <a
                        href="/quick-links/student-testimonial"
                        class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
                    >
                        View More
                    </a>
                </div>
            </div>
        </div>-->

        <div id="gallery">
            <div class="container-fluid mb-10">
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-3/5 md:pr-4 mb-4 md:mb-0">
                        <img src="assets/img/academic-blocks/block-c.jpg" alt="Image 1"
                             class="w-full h-[500px] shadow-lg">
                    </div>
                    <div class="w-full md:w-2/5 md:pl-4">
                        <iframe class="w-full h-[500px] object-cover shadow-lg"
                                src="https://www.youtube.com/embed/RSa3v7KV2h4?si=qWzM2swYFmjZ0Sgm"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div id="recruiters" class="w-full">
            <div class="bg-blue-100 text-center font-sans py-12">
                <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
                <div class="flex items-center justify-center gap-6 py-4">
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="prevSlide()">&#10094;
                    </button>
                    <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                        <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                             [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                            <div *ngFor="let recruiter of recruiters"
                                 class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                                <img [src]="recruiter.logo" [alt]="recruiter.name"
                                     class="max-w-[80px] sm:max-w-[100px] h-auto">
                            </div>
                        </div>
                    </div>
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="nextSlide()">&#10095;
                    </button>
                </div>
                <!--                <button class="mt-4 bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-full">View all</button>-->
            </div>
        </div>
    </div>
</section>
